/*eslint-disable*/
import CircularLoading from "../../../components/CircularLoading";
import { Select } from "@material-ui/core";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  FormText,
  Row,
  Col,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useContext } from "react";
import AlertDialog from "../../../components/AlertDialog";
import { FirebaseContext } from "common";
import CustomInput from "components/CustomInput/CustomInput";
import MenuItem from "@material-ui/core/MenuItem";
import { useNavigate } from "react-router-dom";
function PatientMedication({ props, route }) {
  /////////////////////////////////////////////////////////
  //REdux
  const { api } = useContext(FirebaseContext);
  const { editMedicalHistory } = api;
  const dispatch = useDispatch();
  const medical = useSelector(
    (state) => state.medicalRecords.medicalHistoryRecords
  );
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const [medicalData, setMedicalData] = useState(medical);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  /////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////
  //useEffect 1
  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setMedicalData(medical);
    }
  }, [medical]);
  const OnSave = () => {
    let payload = {
      Medical_Information: {
        ...medical,
        Medication: medicalData?.Medication ? medicalData?.Medication : null,
      },
    };
    console.log("this is basic payload:", payload);
    dispatch(editMedicalHistory(payload, "Add medical history"));
    setCommonAlert({
      open: true,
      msg: "Your Medication History Has Been Saved",
    });
    navigate(-1);
  };
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  return auth.loading ? (
    <CircularLoading />
  ) : (
    <>
      <div className="content">
        <div className="medicalhistory-form">
          <Row>
            <Col md="12">
              <AlertDialog
                open={commonAlert.open}
                onClose={handleCommonAlertClose}
              >
                {commonAlert.msg}
              </AlertDialog>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4"> MEDICATION</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <FormText color="default" tag="span">
                      Please Fill in the Medication you are Currently using:
                    </FormText>
                  </FormGroup>
                  {[1, 2, 3].map((index) => {
                    const medication = medicalData?.Medication?.[`Medication${index}`] || {};
                    return (
                      <div key={index} >
                        <Row>
                          <Col md="3" className="mb-3">
                            <Label for={`Drug${index}`}>Drug</Label>
                            <Input
                              id={`Drug${index}`}
                              type="text"
                              value={medication.Drug || ""}
                              onChange={(e) =>
                                setMedicalData((prev) => ({
                                  ...prev,
                                  Medication: {
                                    ...prev.Medication,
                                    [`Medication${index}`]: {
                                      ...prev.Medication?.[`Medication${index}`],
                                      Drug: e.target.value,
                                    },
                                  },
                                }))
                              }
                            />
                          </Col>

                          <Col md="3" className="mb-3">
                            <Label for={`Form${index}`}>Form</Label>
                            <Input
                              id={`Form${index}`}
                              type="select"
                              value={medication.Form || ""}
                              onChange={(e) =>
                                setMedicalData((prev) => ({
                                  ...prev,
                                  Medication: {
                                    ...prev.Medication,
                                    [`Medication${index}`]: {
                                      ...prev.Medication?.[`Medication${index}`],
                                      Form: e.target.value,
                                    },
                                  },
                                }))
                              }
                            >
                              <option value="">Select</option>
                              <option value="Tablet">Tablet</option>
                              <option value="Liquid">Liquid</option>
                              <option value="Injection">Injection</option>
                            </Input>
                          </Col>

                          <Col md="3" className="mb-3">
                            <Label for={`Dose${index}`}>Dose (mg)</Label>
                            <Input
                              id={`Dose${index}`}
                              type="text"
                              value={medication.Dose || ""}
                              onChange={(e) =>
                                setMedicalData((prev) => ({
                                  ...prev,
                                  Medication: {
                                    ...prev.Medication,
                                    [`Medication${index}`]: {
                                      ...prev.Medication?.[`Medication${index}`],
                                      Dose: e.target.value, // Only allow numbers/decimal
                                    },
                                  },
                                }))
                              }
                            />
                          </Col>

                          <Col md="3" className="mb-3">
                            <Label for={`Frequency${index}`}>Frequency</Label>
                            <Input
                              id={`Frequency${index}`}
                              type="select"
                              value={medication.Frequency || ""}
                              onChange={(e) =>
                                setMedicalData((prev) => ({
                                  ...prev,
                                  Medication: {
                                    ...prev.Medication,
                                    [`Medication${index}`]: {
                                      ...prev.Medication?.[`Medication${index}`],
                                      Frequency: e.target.value,
                                    },
                                  },
                                }))
                              }
                            >
                              <option value="">Select</option>
                              <option value="Daily">Daily</option>
                              <option value="Weekly">Weekly</option>
                              <option value="Monthly">Monthly</option>
                            </Input>
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                  <div className="text-end">
                    <Button color="primary" onClick={OnSave}>
                      SAVE
                    </Button>
                  </div>
                </CardBody>

              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
export default PatientMedication;
